import { render, staticRenderFns } from "./CatalogueTile.vue?vue&type=template&id=8c1ce212&scoped=true&"
import script from "./CatalogueTile.vue?vue&type=script&lang=js&"
export * from "./CatalogueTile.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueTile.vue?vue&type=style&index=0&id=8c1ce212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1ce212",
  null
  
)

export default component.exports